import React, { useState, useMemo } from 'react';
import { IWatchesRanges, regexForRanges } from '../../watchesState/watchesContext';
import { Rule } from 'antd/lib/form';
import FormInput from 'components/Input/FormInput';
import style from './Watches.module.scss';

interface IWatches {
	changeWatchesTableRanges(rangeId: string, range: string): void;
	watchesTableRanges: IWatchesRanges[];
}

const Watches: React.FC<IWatches> = ({ changeWatchesTableRanges, watchesTableRanges }) => {
	const [validValue, setValidValue] = useState<string>('');
	const validationRules = useMemo<Rule[]>(
		() => [
			{ required: true, message: 'Enter table ranges. Example: 1-15;20-25' },
			() => ({
				validator(_, value) {
					if (value && !value.match(regexForRanges)) {
						return Promise.reject(new Error('Separators cannot be repeated. Example: 1-15;20-25'));
					}
					return Promise.resolve();
				},
			}),
		],
		[],
	);

	const handleChange = (rangeId: string, value: string) => {
		if (/^[0-9.;\\-]+$/g.test(value) || value === '') {
			setValidValue(value);
			changeWatchesTableRanges(rangeId, value);
			return value;
		}
		changeWatchesTableRanges(rangeId, validValue);
		return validValue;
	};

	const watchesTableRangesList = useMemo(() => {
		return watchesTableRanges.map((el, i) => (
			<FormInput
				testId={`WatchField-${el.id}`}
				name={el.id}
				label={`Table range for watch ${i + 1}`}
				onChange={(value) => handleChange(el.id, value)}
				validationRules={validationRules}
				placeholder="Enter by example: 1-15;20-25"
				key={el.id}
			/>
		));
	}, [watchesTableRanges]);

	return <div className={style.container}>{watchesTableRangesList}</div>;
};

export default React.memo(Watches);
